export class CreateAwsPrivateLinkInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceName",
            "baseName": "serviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "fqdn",
            "baseName": "fqdn",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupRules",
            "baseName": "securityGroupRules",
            "type": "Array<SecurityGroupRule>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateAwsPrivateLinkInput.attributeTypeMap;
    }
    constructor() {
    }
}
